import { useState, useEffect } from 'react';
import { leaderboardEvents } from '../../../api/leaderboard-events';

interface UseAgencyOptionsProps {
  eventId: number;
  allowedAgencyNames?: string;
  isOpen: boolean;
}

export const useAgencyOptions = ({
  eventId,
  allowedAgencyNames,
  isOpen,
}: UseAgencyOptionsProps) => {
  const [agencyOptions, setAgencyOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    const loadAgencies = async () => {
      try {
        const list = await leaderboardEvents.getAgencies(eventId);
        let options = list.map((a) => ({ value: String(a.id), label: a.name }));

        if (allowedAgencyNames) {
          const names = allowedAgencyNames
            .split(',')
            .map((s) => s.trim().toLowerCase())
            .filter(Boolean);
          if (names.length) {
            const exact = options.filter((opt) => names.includes(opt.label.toLowerCase()));
            options =
              exact.length > 0
                ? exact
                : options.filter((opt) => names.some((n) => opt.label.toLowerCase().includes(n)));
          }
        }

        setAgencyOptions(options);
      } catch {
        setAgencyOptions([]);
      }
    };

    if (isOpen) {
      loadAgencies();
    }
  }, [eventId, isOpen, allowedAgencyNames]);

  return { agencyOptions };
};
